export const USER_TYPES = {
  MENTOR: 'Mentor',
  MANAGER: 'Manager',
  STUDENT: 'Student',
  LSMUSIS: 'Lsmusis'
};